const ANDROID_PACKAGE = 'com.investtor.app'

const isTWA = () => window.document.referrer === `android-app://${ANDROID_PACKAGE}`

export {
  isTWA,
}
